import { render, staticRenderFns } from "./chengyuanXq.vue?vue&type=template&id=0f94822a&scoped=true"
import script from "./chengyuanXq.vue?vue&type=script&lang=js"
export * from "./chengyuanXq.vue?vue&type=script&lang=js"
import style0 from "./chengyuanXq.vue?vue&type=style&index=0&id=0f94822a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f94822a",
  null
  
)

export default component.exports